export const BRIDAL_STATUS = {
  new_enquiry: { l: "New Enquiry", c: "bg-[#FCE9C8] text-[#7A4E00]" },
  contacted: { l: "Contacted", c: "bg-[#E3ECF7] text-[#24456E]" },
  quote_sent: { l: "Quote Sent", c: "bg-[#E8E3F5] text-[#4A3A7A]" },
  awaiting_deposit: { l: "Awaiting Deposit", c: "bg-[#FDE2D6] text-[#8A3A12]" },
  confirmed: { l: "Confirmed", c: "bg-[#D9F0E0] text-[#1E5B33]" },
  trial_booked: { l: "Trial Booked", c: "bg-[#D6EEF0] text-[#145056]" },
  final_details: { l: "Final Details", c: "bg-[#EDE6D6] text-[#5E4B1E]" },
  balance_due: { l: "Balance Due", c: "bg-[#FBDCE2] text-[#8B1B3A]" },
  paid_in_full: { l: "Paid in Full", c: "bg-[#C9EBD3] text-[#134A26]" },
  wedding_complete: { l: "Wedding Complete", c: "bg-[#2A1F27] text-[#FAF7F2]" },
  declined: { l: "Declined / Unavailable", c: "bg-[#ECECEC] text-[#555]" },
};

export const STATUS_KEYS = Object.keys(BRIDAL_STATUS);

export const StatusBadge = ({ status, testId }) => {
  const m = BRIDAL_STATUS[status] || BRIDAL_STATUS.new_enquiry;
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium whitespace-nowrap ${m.c}`}>
      {m.l}
    </span>
  );
};

export const parseDate = (iso) => {
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso || "") ? new Date(`${iso}T00:00:00`) : null;
  return d && !isNaN(d) ? d : null;
};

export const daysUntil = (iso) => {
  const d = parseDate(iso);
  if (!d) return null;
  const t = new Date(); t.setHours(0, 0, 0, 0);
  return Math.round((d - t) / 86400000);
};

export const countdownLabel = (iso) => {
  const n = daysUntil(iso);
  if (n === null) return "";
  if (n === 0) return "Today";
  if (n === 1) return "Tomorrow";
  if (n < 0) return `${Math.abs(n)} days ago`;
  if (n < 60) return `In ${n} days`;
  return `In ${Math.round(n / 30.4)} months`;
};

export const prettyDate = (iso, opts = { weekday: "short", day: "numeric", month: "short", year: "numeric" }) => {
  const d = parseDate(iso);
  return d ? d.toLocaleDateString("en-GB", opts) : iso || "—";
};
